import classNames from "classnames";
import React, { useState } from "react";
import {
  GOVGR_ADMIN_HEADER,
  GOVGR_ADMIN_HEADER_CONTAINER,
  GOVGR_ADMIN_MAIN_CONTENT,
  GOVGR_ADMIN_MAIN_WRAPPER,
  GOVGR_LAYOUT_WRAPPER,
  GOVGR_LAYOUT_WRAPPER_FULL_HEIGHT,
} from "../../conf/styles/GovGrDrawerMenu";
import GovGrUserInfo from "../GovGrUserInfo";
import { GOV_WIDTH_HAMBURGER_MENU_MOBILE_DEVICES } from "./constants";
import DropDownMenu from "./DropDownMenu";
import Footer from "./Footer";
import HambugerMenu from "./HambugerMenu";
import HeaderContent from "./HeaderContent";
import SideBarWithItems from "./SideBarWithItems";
import { WindowWidth } from "./WindowWidth";

const GovGrDrawerMenu = ({ children, apptitle = "App", ...props }) => {
  const isScreenDesktop = WindowWidth(GOV_WIDTH_HAMBURGER_MENU_MOBILE_DEVICES);

  const [isMenuForMobileClose, setIsMenuForMobileClose] = useState(true);

  const ChildrenWrapper = classNames(
    { "govgr-grid__col-span-10": !props.hiddenmenu },
    { "govgr-grid__col-span-12": props.hiddenmenu }
  );
  return (
    <div
      className={`${GOVGR_LAYOUT_WRAPPER} ${GOVGR_LAYOUT_WRAPPER_FULL_HEIGHT}`}
    >
      <header
        role="banner"
        data-module="govgr-header"
        className={GOVGR_ADMIN_HEADER}
      >
        <div
          className={`${GOVGR_ADMIN_HEADER_CONTAINER} xs:flex-col md:flex-row`}
        >
          <HeaderContent
            apptitle={apptitle}
            hamburgermenu={
              <HambugerMenu
                hiddenbutton={isScreenDesktop}
                openmenu={() => setIsMenuForMobileClose(false)}
                hiddenmenu={props.hiddenmenu}
              />
            }
          />

          <div className="flex items-center justify-center xs:flex-col md:flex-row xs:space-y-3">
            <div className="xs:flex md:flex-none">
              {props.userinfo ? props.userinfo : <></>}
              {props.navbardropdownoptions ? (
                <DropDownMenu dropdownoptions={props.navbardropdownoptions} />
              ) : (
                <></>
              )}
            </div>
            {props.languageselector ? props.languageselector : <></>}
          </div>
        </div>
      </header>
      <div className={`${GOVGR_ADMIN_MAIN_WRAPPER} flex-1`}>
        <SideBarWithItems
          hiddenicon={isScreenDesktop}
          closemenu={() => setIsMenuForMobileClose(true)}
          ismenuformobileopen={isScreenDesktop ? false : isMenuForMobileClose}
          menucomponent={props.menucomponent}
          hiddenmenu={props.hiddenmenu}
        />

        <div className={ChildrenWrapper}>
          <div className="h-full max-w-[100%] m-2">{children}</div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GovGrDrawerMenu;
